import React from "react";

const DictionaryTab = ({
  definitionResults,
  definitionLoading,
  definitionQuery,
  onSearchInLyrics,
}) => {
  return (
    <div>
      {definitionLoading && (
        <div className="text-center py-8 text-forest-300">
          Looking up definition...
        </div>
      )}

      {definitionResults && (
        <div className="space-y-4">
          {definitionResults.length > 0 ? (
            definitionResults.map((entry, entryIndex) => (
              <div
                key={entryIndex}
                className="rounded-lg border p-6 transition-colors bg-forest-800 border-forest-600"
              >
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-xl font-semibold text-forest-100">
                    {entry.word}
                  </h2>
                  <button
                    onClick={() => onSearchInLyrics(entry.word)}
                    className="text-sm px-3 py-1 rounded transition-colors bg-forest-700 hover:bg-forest-600 text-forest-200"
                  >
                    Search in lyrics
                  </button>
                </div>

                {entry.phonetics && entry.phonetics[0] && (
                  <p className="text-sm mb-4 text-forest-300">
                    {entry.phonetics[0].text}
                  </p>
                )}

                {entry.meanings.map((meaning, meaningIndex) => (
                  <div key={meaningIndex} className="mb-4">
                    <h3 className="font-medium mb-2 text-forest-200">
                      {meaning.partOfSpeech}
                    </h3>
                    <div className="space-y-2">
                      {meaning.definitions.slice(0, 3).map((def, defIndex) => (
                        <div key={defIndex}>
                          <p className="text-forest-200">
                            {defIndex + 1}. {def.definition}
                          </p>
                          {def.example && (
                            <p className="text-sm italic mt-1 text-forest-300">
                              Example: "{def.example}"
                            </p>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ))
          ) : (
            <div className="text-center py-8 text-forest-300">
              No definition found for "{definitionQuery}"
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DictionaryTab;
